export enum AppEnvironments {
  prod = 'prod',
  stage = 'stage',
  test = 'test',
  development = 'development',
  integration = 'integration',
  local = 'local',
}
